import { useSelector } from 'react-redux';

export const optionsRadio = [
  [
    {
      name: 'motiveClient',
      value: 'Seguir esperando mi producto',
    },
    {
      name: 'motiveClient',
      value: 'Anular compra',
    },
  ],
];

export const MakeFields = () => {
  const { rut, orderId, purchaseDate, cud, sku } = useSelector(
    (state) => state.issuesSlice,
  );

  return [
    {
      name: 'motiveClient',
      inputType: 'radio',
      disabled: true,
      required: true,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'orderId',
      inputAdornment: '',
      label: 'N° de orden de compra',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'purchaseDate',
      inputType: 'date',
      inputAdornment: '',
      label: 'Fecha de compra',
      textArea: '',
      disabled: true,
      required: true,
      value: purchaseDate,
      helper: 'AAAA-MM-DD',
      hidden: true,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      inputAdornment: '',
      label: 'Cuéntanos el inconveniente',
      disabled: false,
      required: true,
      rows: 4,
      multiline: true,
    },
  ];
};
